export default "__VITE_ASSET__DIFHQcte__"